<template>
    <header class="header">
        <nav class="uk-navbar-container uk-grid-match navbar" uk-navbar>
            <div class="uk-navbar-left uk-margin-left header-breakpoint-hidden">
                <div class="uk-flex uk-flex-middle">
                    <div>
                        <div class="uk-flex uk-flex-middle" uk-grid>
                            <div>
                                <span class="uk-h2 header-text header-text--vw">Nathan Nankervis</span>
                            </div>
                            <div>
                                <span class="uk-h3 header-text header-text--vw">
                                    <span class="red">Artist</span> <span class="yellow">&amp; Studio</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="uk-navbar-center">
                <ul class="uk-navbar-nav">
                    <li>
                        <router-link :to="'/'" class="logo-container">
                            <anim-logo />
                            <!-- Add fallback -->
                        </router-link>
                    </li>                    
                </ul>
            </div>
            <div class="uk-Insta-link-mobile">
                <a href="https://www.instagram.com/nathan.nankervis/?hl=en" target="_blank"><instagram-logo /></a>
            </div>
            <div class="uk-navbar-right uk-margin-right">
                <template v-if="!$store.state.menus.loaded">
                    <ul class="uk-navbar-nav placeholder--nav header-breakpoint-hidden">
                        <li v-for="n in 3" :key="n" class="placeholder--text"><span>Placeholder</span></li>
                    </ul>
                    <ul class="uk-navbar-nav placeholder--nav header-breakpoint-visible">
                        <li class="placeholder--text"><span>Menu</span></li>
                    </ul>
                </template>
                
                <template v-else>
                    <v-nav :data="menuFields" class="header-breakpoint-hidden" />
                    <v-mobile-nav :data="menuFields" class="header-breakpoint-visible" />
                </template>
            </div>
        </nav>
    </header>
</template>

<script>
import Nav from '@/components/Nav'
import MobileNav from '@/components/MobileNav'
import AnimLogo from '@/components/AnimLogo'
import InstagramLogo from '@/assets/img/white-instagram.svg'

export default {
    components: {
        'v-nav': Nav,
        'v-mobile-nav': MobileNav,
        AnimLogo,
        InstagramLogo
    },
    computed: {
        menuFields () {
            if (this.$store.state.menus.loaded) {
                const menus = { ...this.$store.getters.menus }
                return menus['header'].fields.menuList
            }
            return null
        }
    }
}
</script>

<style lang="scss">
// moved to scss/components/_nav.scss
</style>



// WEBPACK FOOTER //
// src/components/Header.vue